import React, { useState } from 'react';
import { Menu, Plus } from 'lucide-react';
import { NuovoInterventoWizard } from './NuovoInterventoWizard';
interface HeaderProps {
  onMenuClick?: () => void;
}
export function Header({
  onMenuClick
}: HeaderProps) {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  return <>
      <header className="bg-white border-b border-border shadow-sm sticky top-0 z-30 h-16 flex items-center justify-between px-4 lg:px-8" data-id="element-72">
        {/* Left: Hamburger Menu (Mobile only) + Logo */}
        <div className="flex items-center gap-4" data-id="element-73">
          {onMenuClick && <button onClick={onMenuClick} className="lg:hidden p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-74">
              <Menu size={24} className="text-gray-600" data-id="element-75" />
            </button>}
        </div>

        {/* Right: Pianifica Pulizia CTA + Avatar */}
        <div className="flex items-center gap-3 ml-auto" data-id="element-76">
          {/* Pianifica Pulizia Button - Secondary outline pill style */}
          <button onClick={() => setIsWizardOpen(true)} className="flex items-center gap-1.5 px-4 py-2 bg-white text-navy border border-border rounded-full text-sm font-semibold hover:bg-muted transition-colors min-h-[36px]" data-id="element-77">
            <Plus size={16} data-id="element-78" />
            <span className="hidden sm:inline" data-id="element-79">Nuovo intervento</span>
            <span className="sm:hidden" data-id="element-80">Pianifica</span>
          </button>

          {/* User Avatar - Hidden on small mobile */}
          <div className="hidden sm:flex items-center gap-3 hover:bg-gray-50 rounded-full p-2 transition-colors cursor-pointer" data-id="element-81">
            <img src="https://cdn.magicpatterns.com/uploads/aDiier9xTcmPNhp9njGfUz/80.jpg" alt="Profilo" className="w-9 h-9 rounded-full border border-border object-cover" data-id="element-82" />
            <div className="text-left hidden lg:block pr-2" data-id="element-83">
              <p className="text-base font-semibold text-navy leading-tight" data-id="element-84">
                Massimo Giri
              </p>
              <p className="text-sm text-gray-500 leading-tight" data-id="element-85">
                massimo@giri.com
              </p>
            </div>
          </div>

          {/* Mobile: Just avatar */}
          <button className="sm:hidden p-2 hover:bg-gray-50 rounded-full transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center" data-id="element-86">
            <img src="https://cdn.magicpatterns.com/uploads/aDiier9xTcmPNhp9njGfUz/80.jpg" alt="Profilo" className="w-9 h-9 rounded-full border border-border object-cover" data-id="element-87" />
          </button>
        </div>
      </header>

      {/* Wizard Modal */}
      <NuovoInterventoWizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-88" />
    </>;
}